import legal from './legal.vue';

export default legal;
